import Sidebar from './Sidebar';
import Box from '@mui/material/Box';
// import Footer from './Footer'; Pas utilisé pour le moment

const Layout = ({children}) => (
    <Box sx={{display: 'flex', minHeight: '100vh'}}>
        <Box sx={{flexShrink: 0}}>
            <Sidebar/>
        </Box>

        <Box sx={{flexGrow: 1, minWidth: 0, display: 'flex', flexDirection: 'column'}}>
            <Box component="main" sx={{flexGrow: 1, p: 2, minWidth: 0}}>
                {children}
            </Box>

            {/*<Footer/>*/}
        </Box>
    </Box>
);

export default Layout;